var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { Component, Vue, Watch } from "vue-facing-decorator";
import { reactive } from 'vue';
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { LicenseState } from "@/app/store/modules/license.state";
import { Feature, AlarmsClient, CompaniesClient, AlarmSeverityEnum, AlarmStatusEnum, AlarmTypeEnum, ComponentTypeEnum, GetAlarmViewPaginatedQuery, LookupsClient, PaginatedEnumerableOfAlarmQuery, SitesClient, SortDescription, SortDirection, SystemAccessQueryModel, SystemComponentsClient, SystemsClient, AlarmAcknowledgeStatusEnum, ClearAlarmsCommand, AlarmModel, MeasurementTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import AlarmCommentsVue from "@/app/vues/company/alarm-comments.vue";
import RouteNames from "@/app/router/routes";
import { ArrayHelper } from "@/app/utils/array-helper";
import { CacheHelper } from "@/app/utils/cache-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import Sorter from "@/common/utils/sorter";
import { AlarmsFilterModel } from "@/app/models/alarms-filter.model";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
import { MeasurementErrorCodesHelper } from "@/app/utils/measurement-error-codes-helper";
import { MeasurementErrorCodeDescriptionHelper } from "@/app/utils/measurement-error-code-description-helper";
import { AssureEditionEnum } from "@/app/api/battery-portal-api";
const alarmsClient = new AlarmsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const systemsClient = new SystemsClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const componentsClient = new SystemComponentsClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
const alarmQuery = new GetAlarmViewPaginatedQuery({
    companyId: null,
    systemId: null,
    siteId: null,
    alarmTypeId: null,
    alarmSeverityId: null,
    alarmStatusId: AlarmStatusEnum.Active,
    alarmSeverityIds: [],
    stringStatusId: null,
    componentId: null,
    startTime: null,
    endTime: null,
    pageNo: 1,
    pageSize: 100
});
let AlarmsVue = class AlarmsVue extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.working = false;
        this.lookupsLoaded = false;
        this.startTimeSet = false;
        this.endTimeSet = false;
        this.showAdvancedFilters = false;
        this.searchAttempted = false;
        this.systemIdFromRoute = null;
        this.alarmSeverityIdFromRoute = null;
        this.acknowledgeStatusFromRoute = null;
        this.previousSystemId = null;
        this.severityFilterKey = 0;
        this.selectAll = false;
        this.lastAlarmSelected = 0;
        this.showAlarmCommentsModal = false;
        this.dateTimeToClearAlarms = new Date();
        this.showClearAlarmsModal = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig(true);
        this.dateFilterOptions = ["W", "M", "3M", "Y", "All", "..."];
        this.dateFilterOption = "";
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "WhenRaised",
            direction: SortDirection.Descending
        }));
        // models
        this.query = new GetAlarmViewPaginatedQuery(JSON.parse(JSON.stringify(alarmQuery)));
        this.currentQuery = new GetAlarmViewPaginatedQuery(JSON.parse(JSON.stringify(alarmQuery)));
        this.data = new PaginatedEnumerableOfAlarmQuery();
        this.columns = [];
        // arrays
        this.companies = [];
        this.systems = [];
        this.sites = [];
        this.alarmTypes = [];
        this.alarmSeverities = [];
        this.alarmStates = [
            {
                value: null,
                text: `Any alarm state`
            },
            {
                value: AlarmStatusEnum.Active,
                text: `Active alarms`
            },
            {
                value: AlarmStatusEnum.Inactive,
                text: `Inactive alarms`
            },
        ];
        this.acknowledgeStatuses = [
            {
                value: null,
                text: `Any alarm status`
            },
            {
                value: AlarmAcknowledgeStatusEnum.Acknowledge,
                text: `Acknowledged`
            },
            {
                value: AlarmAcknowledgeStatusEnum.Unacknowledge,
                text: `Not acknowledged`
            },
        ];
        this.stringStates = [];
        this.systemComponents = [];
        this.blockLookupCache = [];
        this.dateFilterPresets = ArrayHelper.defaultDateFilters;
        this.tooltipCache = reactive({});
    }
    created() {
        var _a;
        this.systemIdFromRoute = parseInt(this.$route.params.systemId) || null;
        let alarmSeverity = this.$route.params.alarmSeverity || null;
        if (alarmSeverity) {
            switch (alarmSeverity) {
                case "warning":
                    this.alarmSeverityIdFromRoute = AlarmSeverityEnum.Warning;
                    break;
                case "critical":
                    this.alarmSeverityIdFromRoute = AlarmSeverityEnum.Critical;
                    break;
                case "info":
                    this.alarmSeverityIdFromRoute = AlarmSeverityEnum.Info;
                    break;
            }
        }
        this.acknowledgeStatusFromRoute = ((_a = this.$route.params) === null || _a === void 0 ? void 0 : _a.acknowledgeStatus) != undefined ? parseInt(this.$route.params.acknowledgeStatus) : null;
    }
    ;
    mounted() {
        this.working = true;
        this.initializeColumns();
        DataGridStateHelper.loadDataGridState("alarm-grid", this.columns, this.sorter);
        this.getLookups();
    }
    ;
    // get
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `All companies` }].concat(companies);
                if (!companies.length)
                    return;
                if (this.query.companyId)
                    return;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    ;
    getLookups() {
        let promises = [
            this.getCompanies(),
            systemsClient
                .getSystems(false, Feature.Alarm_View)
                .then(response => {
                if (!response)
                    return;
                let systemModel = new SystemAccessQueryModel();
                systemModel.init({});
                systemModel.displayName = `Any system`;
                this.systems = [systemModel].concat(response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            alarmsClient
                .getAlarmTypes()
                .then(response => {
                let alarmTypes = (response || []).map((item) => {
                    return {
                        value: item.alarmTypeId,
                        text: item.alarmTypeName || ""
                    };
                });
                this.alarmTypes = [{ value: null, text: `Any alarm type` }].concat(alarmTypes);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            alarmsClient
                .getAlarmSeverities()
                .then(response => {
                let alarmSeverities = (response || []).map((item) => {
                    return {
                        value: item.alarmSeverityId,
                        text: item.alarmSeverityName || "",
                        selected: false
                    };
                });
                this.alarmSeverities = alarmSeverities;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            lookupsClient
                .getStringStates()
                .then(response => {
                let stringStates = (response || []).map((item) => {
                    return {
                        value: item.statusId,
                        text: item.statusName || ""
                    };
                });
                this.stringStates = [{ value: null, text: `Any string state` }].concat(stringStates);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
        ];
        Promise.all(promises).then(() => {
            this.working = false;
            this.lookupsLoaded = true;
            let hasQueryStringFilters = this.systemIdFromRoute || this.alarmSeverityIdFromRoute || queryStringHelper.hasQueryString();
            if (hasQueryStringFilters) {
                this.working = false;
                if (queryStringHelper.hasParameter("alarmId")) {
                    queryStringHelper.setFromQueryString("alarmId", null, (value) => {
                        this.query.alarmId = value ? parseInt(value) : null;
                        this.dateFilterOption = "All";
                        return this.query.alarmId;
                    });
                }
                // Company
                if (queryStringHelper.hasParameter("companyId")) {
                    queryStringHelper.setFromQueryString("companyId", null, (value) => {
                        this.query.companyId = value ? parseInt(value) : null;
                        return this.query.companyId;
                    });
                }
                // system
                if (queryStringHelper.hasParameter("systemId")) {
                    queryStringHelper.setFromQueryString("systemId", null, (value) => {
                        this.query.systemId = value ? parseInt(value) : null;
                        return this.query.systemId;
                    });
                }
                else if (this.systemIdFromRoute)
                    this.query.systemId = this.systemIdFromRoute;
                // site
                if (queryStringHelper.hasParameter("siteId"))
                    queryStringHelper.setFromQueryString("siteId", null, (value) => {
                        this.query.siteId = value ? parseInt(value) : null;
                        return this.query.siteId;
                    });
                // alarm type
                if (queryStringHelper.hasParameter("alarmTypeId"))
                    queryStringHelper.setFromQueryString("alarmTypeId", null, (value) => {
                        this.query.alarmTypeId = value ? parseInt(value) : null;
                        return this.query.alarmTypeId;
                    });
                // alarm severity
                if (queryStringHelper.hasParameter("alarmSeverity")) {
                    try {
                        queryStringHelper.setFromQueryString("alarmSeverity", this.alarmSeverities, (value) => {
                            let options = value === null || value === void 0 ? void 0 : value.split(',');
                            this.alarmSeverities.forEach(alarmSeverity => alarmSeverity.selected = (options === null || options === void 0 ? void 0 : options.indexOf(`${alarmSeverity.value}`)) !== -1);
                            return this.alarmSeverities;
                        });
                    }
                    catch (_a) {
                        // set all selected upon encoutnering an exception.
                        this.alarmSeverities.forEach(alarmSeverity => alarmSeverity.selected = true);
                    }
                }
                else if (this.alarmSeverityIdFromRoute) {
                    let alarmSeverity = this.alarmSeverities.filter(match => match.value == this.alarmSeverityIdFromRoute)[0];
                    if (alarmSeverity)
                        alarmSeverity.selected = true;
                }
                else
                    this.alarmSeverities.forEach(alarmSeverity => alarmSeverity.selected = true);
                // alarm status
                if (queryStringHelper.hasParameter("alarmStatusId"))
                    queryStringHelper.setFromQueryString("alarmStatusId", null, (value) => {
                        this.query.alarmStatusId = value ? parseInt(value) : null;
                        this.query.alarmStatusId = this.query.alarmStatusId == -1 ? null : this.query.alarmStatusId;
                        return this.query.alarmStatusId;
                    });
                // alarm status
                if (queryStringHelper.hasParameter("acknowledgeStatus")) {
                    queryStringHelper.setFromQueryString("acknowledgeStatus", null, (value) => {
                        this.query.acknowledgeStatus = value ? parseInt(value) : null;
                        return this.query.acknowledgeStatus;
                    });
                }
                else if (this.acknowledgeStatusFromRoute != null) {
                    this.query.acknowledgeStatus = this.acknowledgeStatusFromRoute;
                }
                // date filter option
                if (queryStringHelper.hasParameter("dateFilterOption")) {
                    queryStringHelper.setFromQueryString("dateFilterOption", null, (value) => {
                        let dateFilterOption = value !== null && value !== void 0 ? value : "W";
                        this.setDateFilterOption(dateFilterOption);
                        return dateFilterOption;
                    });
                }
                // start time
                if (this.dateFilterOption == "...") {
                    if (queryStringHelper.hasParameter("startTime")) {
                        queryStringHelper.setFromQueryString("startTime", null, (value) => {
                            let startTime = value ? DateHelper.convertToDate(value) : null;
                            this.query.startTime = startTime;
                            return this.query.startTime;
                        });
                    }
                    // end time
                    if (queryStringHelper.hasParameter("endTime")) {
                        queryStringHelper.setFromQueryString("endTime", null, (value) => {
                            let endTime = value ? DateHelper.convertToDate(value) : null;
                            this.query.endTime = endTime;
                            return this.query.endTime;
                        });
                    }
                }
                this.search(true);
                return;
            }
            if (this.cachedItemExists()) {
                this.initializeCachedFilters();
                this.search(true);
                return;
            }
            this.setDefaultFilters();
            this.search(true);
        });
    }
    ;
    search() {
        return __awaiter(this, arguments, void 0, function* (resetPage = false, fromButton = false) {
            if (this.working)
                return;
            if (this.startDateInvalid || this.endDateInvalid) {
                Notifier.onWarning(`Please enter valid dates.`);
                return;
            }
            let query = this.query;
            query.startTime = query.startTime ? DateHelper.convertToDate(query.startTime.toString()) : null;
            query.endTime = query.endTime ? DateHelper.convertToDate(query.endTime.toString()) : null;
            if (!DateHelper.validateDateRange(query.startTime, query.endTime)) {
                Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
                return;
            }
            this.loading = true;
            this.working = true;
            let selectedAlarmSeverities = this.alarmSeverities
                .filter(alarmSeverity => alarmSeverity.selected)
                .map(alarmSeverity => Number(alarmSeverity.value));
            query.alarmSeverityIds = selectedAlarmSeverities;
            if (fromButton) {
                query.alarmId = null;
            }
            if (resetPage || this.currentQuery == null) {
                this.currentQuery = JSON.parse(JSON.stringify(query));
                query.pageNo = 1;
                this.currentQuery.pageNo = 1;
            }
            else {
                this.currentQuery.pageNo = query.pageNo;
                this.currentQuery.pageSize = query.pageSize;
                this.currentQuery.sort = query.sort;
            }
            return yield alarmsClient
                .search(this.currentQuery)
                .then(response => {
                var _a, _b;
                if (!response)
                    return;
                this.data = response;
                this.query.pageNo = this.data.displayedPage;
                this.query.pageSize = this.data.pageSize;
                if (resetPage && response.message) {
                    Notifier.onWarning(response.message);
                }
                if (this.query.alarmId && ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.records) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    var alarm = this.data.records[0];
                    this.query.systemId = alarm.systemId;
                    this.query.siteId = alarm.siteId;
                }
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
                this.removeCachedFilters();
            })
                .finally(() => {
                this.working = false;
                this.searchAttempted = true;
                this.loading = false;
                if (resetPage) {
                    this.storeFiltersToCache();
                    this.updateQueryString();
                }
            });
        });
    }
    ;
    reload() {
        // If query has an alarmId from query string, retain it for reloads
        if (queryStringHelper.hasParameter("alarmId")) {
            queryStringHelper.setFromQueryString("alarmId", null, (value) => {
                this.query.alarmId = value ? parseInt(value) : null;
                this.currentQuery.alarmId = this.query.alarmId;
                return this.query.alarmId;
            });
        }
        this.search();
    }
    cachedItemExists() {
        return CacheHelper.getItem(RouteNames.Alarms, "AlarmsFilterModel") != null;
    }
    ;
    /** Initializes default search parameters based on cache */
    initializeCachedFilters() {
        var _a;
        let cachedFilterModel = CacheHelper.getItem(RouteNames.Alarms, "AlarmsFilterModel");
        this.query = (_a = cachedFilterModel === null || cachedFilterModel === void 0 ? void 0 : cachedFilterModel.query) !== null && _a !== void 0 ? _a : this.query;
        // Initialize Alarm Severities from cache (these do not update when changing this.query)
        this.alarmSeverities.forEach(alarmSeverity => {
            var _a;
            if (((_a = this.query.alarmSeverityIds) === null || _a === void 0 ? void 0 : _a.includes(Number(alarmSeverity.value))) || Number(alarmSeverity.value) == this.query.alarmSeverityId)
                alarmSeverity.selected = true;
        });
        if (cachedFilterModel === null || cachedFilterModel === void 0 ? void 0 : cachedFilterModel.dateFilterOption) {
            var cachedDateFilterOption = cachedFilterModel.dateFilterOption;
            if (cachedDateFilterOption == "...")
                cachedDateFilterOption = "W";
            this.setDateFilterOption(cachedDateFilterOption);
        }
    }
    ;
    storeFiltersToCache() {
        let cachedFilterModel = new AlarmsFilterModel();
        this.currentQuery.alarmId = null;
        cachedFilterModel.query = this.currentQuery;
        cachedFilterModel.dateFilterOption = this.dateFilterOption;
        CacheHelper.storeItem(RouteNames.Alarms, "AlarmsFilterModel", cachedFilterModel);
    }
    ;
    removeCachedFilters() {
        CacheHelper.removeItem(RouteNames.Alarms, "AlarmsFilterModel");
    }
    ;
    onSelectAllChanged() {
        if (!this.data.records)
            return;
        this.data.records.forEach(alarm => alarm.selected = this.selectAll);
    }
    ;
    onColumnsChanged() {
        if (this.working)
            return;
        DataGridStateHelper.storeDataGridState("alarm-grid", this.columns, this.sorter);
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            DataGridStateHelper.storeDataGridState("alarm-grid", this.columns, this.sorter);
            this.search();
        }
    }
    ;
    onPageChanged() {
        this.search();
    }
    ;
    setDefaultStartTime() {
        if (this.startTimeSet)
            return;
        this.query.startTime = DateHelper.getStartOfDay(DateHelper.convertToDate((this.query.startTime || new Date()).toString()));
        this.startTimeSet = true;
    }
    ;
    setDefaultEndTime() {
        if (this.endTimeSet)
            return;
        this.query.endTime = DateHelper.getEndOfDay(DateHelper.convertToDate((this.query.endTime || new Date()).toString()));
        this.endTimeSet = true;
    }
    ;
    onCompanyIdChanged() {
        var _a;
        if (this.query.companyId != null) {
            if (this.systemId != null && ((_a = this.system) === null || _a === void 0 ? void 0 : _a.companyId) != this.query.companyId)
                this.system = this.filteredSystems[0];
            if (this.siteId != null) {
                let site = this.sites.find(site => site.siteId == this.query.siteId);
                if (site && site.companyId != this.query.companyId)
                    this.site = this.filteredSites[0];
            }
        }
    }
    onSiteIdChanged() {
        var _a;
        if (((_a = this.system) === null || _a === void 0 ? void 0 : _a.siteId) != this.siteId)
            this.system = this.filteredSystems[0];
    }
    // set
    setDefaultFilters() {
        this.query.alarmStatusId = AlarmStatusEnum.Active;
        this.query.alarmSeverityId = null;
        this.resetDateFilterOption();
        this.alarmSeverities.forEach(alarmSeverity => alarmSeverity.selected = true);
    }
    ;
    resetFilters() {
        this.query = new GetAlarmViewPaginatedQuery(JSON.parse(JSON.stringify(alarmQuery)));
        this.query.systemId = null;
        this.query.alarmSeverityId = null;
        this.query.alarmStatusId = null;
        this.query.alarmTypeId = null;
        this.resetDateFilterOption();
        this.alarmSeverities.forEach(alarmSeverity => alarmSeverity.selected = true);
        this.data = new PaginatedEnumerableOfAlarmQuery();
        CacheHelper.removeItem(RouteNames.Alarms, GetAlarmViewPaginatedQuery.toString());
    }
    ;
    /**
     * Update URL query string with current filter values.
     **/
    updateQueryString() {
        let params = [
            { value: this.query.companyId, parameterName: "companyId" },
            { value: this.query.siteId, parameterName: "siteId" },
            { value: this.query.alarmTypeId, parameterName: "alarmTypeId" },
            { value: this.query.alarmStatusId == null ? -1 : this.query.alarmStatusId, parameterName: "alarmStatusId" },
            { value: this.query.acknowledgeStatus, parameterName: "acknowledgeStatus" },
            { value: this.dateFilterOption, parameterName: "dateFilterOption" },
        ];
        if (!this.systemIdFromRoute)
            params.push({ value: this.query.systemId, parameterName: "systemId" });
        if (!this.alarmSeverityIdFromRoute) {
            let alarmSeverities = this.alarmSeverities.filter(severity => severity.selected).map(severity => severity.value).join(",");
            params.push({ value: alarmSeverities, parameterName: "alarmSeverity" });
        }
        let startTime = this.query.startTime ? DateHelper.convertToDate(this.query.startTime.toString()).toISOString() : null;
        let endTime = this.query.endTime ? DateHelper.convertToDate(this.query.endTime.toString()).toISOString() : null;
        if (this.dateFilterOption == "...") {
            params.push({ value: startTime, parameterName: "startTime" });
            params.push({ value: endTime, parameterName: "endTime" });
        }
        queryStringHelper.updateQueryStrings(params);
    }
    ;
    goToSystemSnapshot(alarm) {
        // Create a unique key and send as parameter to reload the last snapshot case the page is cached.
        const uniqueKey = Math.floor(new Date().getTime() / 1000).toString();
        const route = { name: RouteNames.SnapshotForSystem, params: { systemId: alarm.systemId.toString(), uniqueKey } };
        if (event && (event.ctrlKey || event.metaKey)) {
            const url = this.$router.resolve(route).href;
            window.open(url, '_blank');
        }
        else {
            this.$router.push(route);
        }
    }
    ;
    goToSnapshot(alarm, event) {
        if (alarm.componentTypeId == ComponentTypeEnum.String) {
            const route = { name: RouteNames.SnapshotForString, params: { systemId: alarm.systemId.toString(), stringId: alarm.systemComponentId.toString() } };
            if (event && (event.ctrlKey || event.metaKey)) {
                const url = this.$router.resolve(route).href;
                window.open(url, '_blank');
            }
            else {
                this.$router.push(route);
            }
            return;
        }
        if (alarm.componentTypeId != ComponentTypeEnum.Block) {
            this.goToSystemSnapshot(alarm, event);
            return;
        }
        this.changeViewBasedOnSelectedBlock(alarm, RouteNames.SnapshotForString, event);
    }
    ;
    goToTrend(alarm, event) {
        if (this.working)
            return;
        const params = {
            systemId: alarm.systemId.toString(),
            stringId: "",
            measurementTypeId: "",
            startDate: DateHelper.getDateForQueryString(DateHelper.addDay(alarm.whenRaised, -7)),
            endDate: this.getAlarmEndDate(alarm)
        };
        if (alarm.measurementTypeId)
            params.measurementTypeId = alarm.measurementTypeId.toString();
        if (alarm.componentTypeId == ComponentTypeEnum.String) {
            params.stringId = alarm.systemComponentId.toString();
            const route = { name: RouteNames.TrendForString, params };
            if (event && (event.ctrlKey || event.metaKey)) {
                const url = this.$router.resolve(route).href;
                window.open(url, '_blank');
            }
            else {
                this.$router.push(route);
            }
            return;
        }
        if (alarm.componentTypeId == ComponentTypeEnum.Sensor && alarm.measurementTypeId == MeasurementTypeEnum.AmbientTemperature) {
            this.working = true;
            let queryStringSensor = {};
            componentsClient
                .getStringForSensor(alarm.systemId, alarm.systemComponentId)
                .then(response => {
                var _a;
                if (!response)
                    return;
                params.stringId = response.componentId.toString();
                if ((_a = alarm.componentName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('temp 2')) {
                    queryStringSensor = { isAmbTemp2: 'true' };
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                const route = { name: RouteNames.TrendForString, params, query: queryStringSensor };
                if (params.stringId && event && (event.ctrlKey || event.metaKey)) {
                    const url = this.$router.resolve(route).href;
                    window.open(url, '_blank');
                }
                else if (params.stringId) {
                    this.$router.push(route);
                }
                else {
                    const sysRoute = { name: RouteNames.TrendForSystem, params };
                    if (event && (event.ctrlKey || event.metaKey)) {
                        const url = this.$router.resolve(sysRoute).href;
                        window.open(url, '_blank');
                    }
                    else {
                        this.$router.push(sysRoute);
                    }
                }
            });
            return;
        }
        if (alarm.componentTypeId != ComponentTypeEnum.Block) {
            const route = { name: RouteNames.TrendForSystem, params };
            if (event && (event.ctrlKey || event.metaKey)) {
                const url = this.$router.resolve(route).href;
                window.open(url, '_blank');
            }
            else {
                this.$router.push(route);
            }
            return;
        }
        this.changeViewBasedOnSelectedBlock(alarm, RouteNames.TrendForMeasurement, event);
    }
    ;
    changeViewBasedOnSelectedBlock(alarm, view, event) {
        if (this.working)
            return;
        if (alarm.componentTypeId == ComponentTypeEnum.String) {
            const route = { name: RouteNames.SnapshotForString, params: { systemId: alarm.systemId.toString(), stringId: alarm.systemComponentId.toString() } };
            if (event && (event.ctrlKey || event.metaKey)) {
                const url = this.$router.resolve(route).href;
                window.open(url, '_blank');
            }
            else {
                this.$router.push(route);
            }
            return;
        }
        if (alarm.componentTypeId != ComponentTypeEnum.Block) {
            this.goToSystemSnapshot(alarm, event);
            return;
        }
        this.working = true;
        const params = {
            systemId: alarm.systemId.toString(),
            blockId: alarm.systemComponentId.toString(),
            stringId: "",
            measurementTypeId: "",
            startDate: DateHelper.getDateForQueryString(DateHelper.addDay(alarm.whenRaised, -7)),
            endDate: this.getAlarmEndDate(alarm)
        };
        if (alarm.measurementTypeId)
            params.measurementTypeId = alarm.measurementTypeId.toString();
        let idx = ArrayHelper.findFirstIndex(this.blockLookupCache, (match) => {
            return alarm.systemComponentId == match.blockId;
        });
        const pushOrOpen = (route) => {
            if (event && (event.ctrlKey || event.metaKey)) {
                const url = this.$router.resolve(route).href;
                window.open(url, '_blank');
            }
            else {
                this.$router.push(route);
            }
        };
        if (idx >= 0) {
            this.working = false;
            let string = this.blockLookupCache[idx];
            params.stringId = string.component.componentId.toString();
            if (view == RouteNames.SnapshotForString)
                pushOrOpen({ name: RouteNames.SnapshotForString, params });
            if (view == RouteNames.TrendForMeasurement)
                pushOrOpen({ name: RouteNames.TrendForMeasurement, params });
            return;
        }
        componentsClient
            .getStringForBlock(alarm.systemId, alarm.systemComponentId)
            .then(response => {
            if (!response)
                return;
            this.blockLookupCache.push({ blockId: alarm.systemComponentId, component: response });
            params.stringId = response.componentId.toString();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            if (view == RouteNames.SnapshotForString)
                pushOrOpen({ name: RouteNames.SnapshotForString, params });
            if (view == RouteNames.TrendForMeasurement)
                pushOrOpen({ name: RouteNames.TrendForMeasurement, params });
        });
    }
    ;
    toggleAdvancedFilterPanel() {
        this.showAdvancedFilters = !this.showAdvancedFilters;
    }
    ;
    initializeColumns() {
        if (this.isStandardOrHigher) {
            this.columns = [
                { visible: true, fieldName: "notes", title: "Notes/Issues" },
                { visible: true, fieldName: "whenRaised", title: "Time" },
                { visible: true, fieldName: "duration", title: "Duration" },
                { visible: true, fieldName: "acknowledged", title: "Acknowledged" },
                { visible: true, fieldName: "state", title: "State" },
                { visible: true, fieldName: "alarmEvent", title: "Event" },
                { visible: true, fieldName: "systemName", title: "System" },
                { visible: true, fieldName: "componentName", title: "Location" },
                { visible: true, fieldName: "alarmDefinitionName", title: "Description" },
                { visible: true, fieldName: "minValue", title: "Value" },
                { visible: true, fieldName: "siteName", title: "Site" },
            ];
        }
        else {
            this.columns = [
                { visible: true, fieldName: "whenRaised", title: "Time" },
                { visible: true, fieldName: "duration", title: "Duration" },
                { visible: true, fieldName: "state", title: "State" },
                { visible: true, fieldName: "systemName", title: "System" },
                { visible: true, fieldName: "componentName", title: "Location" },
                { visible: true, fieldName: "alarmDefinitionName", title: "Description" },
                { visible: true, fieldName: "minValue", title: "Value" },
                { visible: true, fieldName: "siteName", title: "Site" },
            ];
        }
    }
    selectColumn(column) {
        this.ensureOneColumnSelected(!column.visible, column);
    }
    ;
    ensureOneColumnSelected(checked, column) {
        if (this.numberOfVisibleColumns <= 1) {
            column.visible = true;
            return;
        }
        column.visible = checked;
    }
    ;
    selectSeverity(severity) {
        this.ensureOneSeveritySelected(!severity.selected, severity);
    }
    ;
    ensureOneSeveritySelected(checked, severity) {
        if (this.numberOfSeletedAlarmSeverities <= 1) {
            severity.selected = true;
            this.severityFilterKey++;
            return;
        }
        severity.selected = checked;
    }
    ;
    getAlarmSeverityFilter(item) {
        return 'severity-' + item.value + this.severityFilterKey;
    }
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    acknowledgeSelectedAlarms() {
        var alarmIds = this.getSelectedAlarmIds();
        if (!alarmIds || alarmIds.length <= 0)
            return;
        this.$confirmModal.show("Do you want to acknowledge selected alarms?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            alarmsClient
                .acknowledgeAlarms(alarmIds)
                .then(() => {
                Notifier.onOk(`Alarms were Acknowledged.`);
                this.working = false;
                this.reload();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    showComments() {
        this.showAlarmCommentsModal = true;
    }
    showCommentsForAlarm(alarm) {
        if (!this.data.records)
            return;
        this.data.records.forEach(item => item.selected = item.alarmId == alarm.alarmId);
        this.showAlarmCommentsModal = true;
    }
    hasIssues(alarm) {
        return alarm.issueIds != null && alarm.issueIds.length > 0;
    }
    goToIssue(alarm) {
        var _a;
        if (!this.data.records)
            return;
        if (((_a = alarm.issueIds) === null || _a === void 0 ? void 0 : _a.length) == 1) {
            var issueId = alarm.issueIds[0].toString();
            const route = {
                name: RouteNames.Issue, params: { id: issueId }
            };
            this.$router.push(route);
        }
        else {
            const route = { name: RouteNames.Issues };
            this.$router.push(route);
        }
    }
    onSelection(alarmId, event) {
        var _a;
        if (!this.data.records)
            return;
        if (event.shiftKey) {
            var previousIdx = this.lastAlarmSelected != 0 ? this.data.records.findIndex(alarm => alarm.alarmId == this.lastAlarmSelected) : 0;
            var currentIdx = this.data.records.findIndex(alarm => alarm.alarmId == alarmId);
            if (previousIdx >= 0 && currentIdx >= 0 && previousIdx != currentIdx) {
                let startIdx = Math.min(previousIdx, currentIdx);
                let endIdx = Math.max(previousIdx, currentIdx);
                event.preventDefault();
                (_a = this.data.records) === null || _a === void 0 ? void 0 : _a.forEach((alarm, idx) => {
                    alarm.selected = idx >= startIdx && idx <= endIdx;
                });
            }
        }
        this.lastAlarmSelected = alarmId;
    }
    getSelectedAlarmIds() {
        if (!this.data.records)
            return [];
        return this.data.records.filter(alarm => alarm.selected).map(alarm => alarm.alarmId);
    }
    getSelectedAlarmComponentId() {
        if (!this.data.records)
            return 0;
        let selected = this.data.records.filter(item => item.selected);
        return (selected === null || selected === void 0 ? void 0 : selected.length) == 1 ? selected[0].systemComponentId : null;
    }
    getSystemIdSelected() {
        var _a;
        if (!this.data.records)
            return 0;
        let selected = this.data.records.filter(item => item.selected);
        return ((_a = selected[0]) === null || _a === void 0 ? void 0 : _a.systemId) || 0;
    }
    // computed
    get filteredSites() {
        var filteredSites = (this.sites || []).filter(site => !this.companyId || site.companyId == this.companyId);
        let sites = (filteredSites).map((item) => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `Any site` }].concat(sites);
        return sites;
    }
    get filteredSystems() {
        if (!this.companyId && !this.siteId)
            return this.systems;
        let systems = this.systems.filter(system => (!this.companyId || system.companyId == this.companyId) && (!this.siteId || system.siteId == this.siteId));
        let systemModel = new SystemAccessQueryModel();
        systemModel.init({});
        systemModel.displayName = `Any system`;
        systems = [systemModel].concat(systems);
        return systems;
    }
    whenRaisedTimeString(alarm) {
        return DateHelper.convertToFriendlyMomentTimeString(alarm.whenRaised);
    }
    ;
    alarmClass(alarm) {
        if (alarm.alarmSeverityId == null)
            return "";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Critical)
            return "critical";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Warning)
            return "warning";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Info)
            return "info";
        return "";
    }
    ;
    acknowledgeButtonDisabled() {
        if (!this.data.records)
            return true;
        return this.data.records.filter(alarm => alarm.selected && alarm.acknowledgeStatus != AlarmAcknowledgeStatusEnum.Acknowledge).length <= 0;
    }
    commentButtonDisabled() {
        return !this.hasUniqueSelectedSystemIds();
    }
    clearVisible() {
        return this.loginState.isPowerShieldAdministrator;
    }
    clearDisabled() {
        if (!this.data.records || !this.loginState.isPowerShieldAdministrator)
            return true;
        return this.data.records.filter(alarm => alarm.selected && alarm.whenCleared === null).length <= 0;
    }
    createIssueDisabled() {
        return !this.hasUniqueSelectedSystemIds();
    }
    hasUniqueSelectedSystemIds() {
        if (!this.data.records)
            return false;
        var selectedAlarms = this.data.records.filter(alarm => alarm.selected);
        if (selectedAlarms.length <= 0)
            return false;
        let systemIds = selectedAlarms.map(alarm => alarm.systemId);
        var uniqueSystemIds = systemIds.filter((value, index, array) => array.indexOf(value) === index);
        return uniqueSystemIds.length == 1;
    }
    showClearAlarms() {
        this.dateTimeToClearAlarms = new Date();
        this.showClearAlarmsModal = true;
    }
    createIssue() {
        return __awaiter(this, void 0, void 0, function* () {
            const selectedAlarms = this.data.records.filter(alarm => alarm.selected);
            if (!selectedAlarms.length)
                return;
            const companyId = selectedAlarms[0].companyId;
            const systemId = selectedAlarms[0].systemId;
            // Get unique component types
            const componentTypeIds = selectedAlarms.map(a => a.componentTypeId);
            const uniqueComponentTypes = Array.from(new Set(componentTypeIds));
            let stringId = null;
            let blockIds = null;
            // 1. stringId: only if all are String and same systemComponentId
            if (uniqueComponentTypes.length === 1 &&
                uniqueComponentTypes[0] === ComponentTypeEnum.String) {
                const allSameSystemComponentId = selectedAlarms.every(a => a.systemComponentId === selectedAlarms[0].systemComponentId);
                stringId = allSameSystemComponentId ? selectedAlarms[0].systemComponentId : null;
            }
            else {
                stringId = null;
            }
            // 2. blockIds: only if all are Block
            if (uniqueComponentTypes.length === 1 &&
                uniqueComponentTypes[0] === ComponentTypeEnum.Block) {
                blockIds = selectedAlarms.map(a => a.systemComponentId);
            }
            else {
                blockIds = null;
            }
            // 3. Sensor or all String/Sensor: get stringId for sensors and check if all stringIds are the same
            if (uniqueComponentTypes.every(t => t === ComponentTypeEnum.String || t === ComponentTypeEnum.Sensor)) {
                const stringIds = [];
                for (const alarm of selectedAlarms) {
                    if (alarm.componentTypeId === ComponentTypeEnum.String) {
                        stringIds.push(alarm.systemComponentId);
                    }
                    else if (alarm.componentTypeId === ComponentTypeEnum.Sensor) {
                        try {
                            const response = yield componentsClient.getStringForSensor(alarm.systemId, alarm.systemComponentId);
                            if (response && response.componentId) {
                                stringIds.push(response.componentId);
                            }
                        }
                        catch (ex) {
                            HttpHelper.handleResponse(ex, () => {
                                Notifier.onServerError(ex);
                            });
                        }
                    }
                }
                const allSameStringId = stringIds.length === selectedAlarms.length &&
                    stringIds.every(id => id === stringIds[0]);
                stringId = allSameStringId ? stringIds[0] : null;
                // blockIds should be null in this case
                blockIds = null;
            }
            // Find the most common alarmDefinitionName
            const description = selectedAlarms
                .map(a => a.alarmDefinitionName)
                .sort((a, b) => selectedAlarms.filter(x => x.alarmDefinitionName === b).length -
                selectedAlarms.filter(x => x.alarmDefinitionName === a).length)[0];
            // Route to /issues with query
            this.$router.push({
                name: RouteNames.Issue,
                query: {
                    companyId,
                    systemId,
                    alarmIds: selectedAlarms.map(a => a.alarmId).join(','),
                    stringId: stringId !== null && stringId !== void 0 ? stringId : undefined,
                    blockIds: blockIds ? blockIds.join(',') : undefined,
                    description
                }
            });
        });
    }
    clearAlarms() {
        var alarmIds = this.data.records
            .filter(alarm => alarm.selected && alarm.whenCleared === null)
            .map(alarm => alarm.alarmId);
        if (!alarmIds || alarmIds.length <= 0)
            return;
        this.$confirmModal.show("Do you want to clear the selected alarms?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            var requestModel = alarmIds.map(alarmId => new AlarmModel({
                alarmId: alarmId,
                whenCleared: DateHelper.convertToDate(this.dateTimeToClearAlarms.toString())
            }));
            var command = new ClearAlarmsCommand({ requestModel: requestModel });
            try {
                alarmsClient
                    .clearAlarms(command)
                    .then(() => {
                    Notifier.onOk(`Alarms were cleared.`);
                    this.working = false;
                    this.showClearAlarmsModal = false;
                    this.search();
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                })
                    .finally(() => {
                    this.working = false;
                });
            }
            catch (e) {
                console.error('error clearing alarms', e);
            }
        });
    }
    closeClearAlarmsModal() {
        this.showClearAlarmsModal = false;
    }
    getAcknowledgeTitle(alarm) {
        return `Acknowleged by ${alarm.userAcknowledgedName || "unknown"} on ${DateHelper.convertToFriendlyMomentTimeString(alarm.whenAcknowledged || null)}`;
    }
    isAcknowledged(alarm) {
        return alarm.acknowledgeStatus == AlarmAcknowledgeStatusEnum.Acknowledge;
    }
    getAlarmState(alarm) {
        return alarm.whenCleared ? "Inactive" : "Active";
    }
    ;
    isErrorAlarm(alarm) {
        return MeasurementErrorCodesHelper.isErrorAlarm(alarm.alarmDefinitionName);
    }
    getErrorCodeDisplay(alarm) {
        return MeasurementErrorCodesHelper.formatErrorCodeDisplay(alarm.minValue, alarm.maxValue, alarm.alarmDefinitionName);
    }
    getErrorCodeTooltip(alarm) {
        if (alarm.minValue == null || alarm.maxValue == null) {
            return 'Invalid error code';
        }
        const minCode = Math.floor(alarm.minValue);
        const maxCode = Math.floor(alarm.maxValue);
        const cacheKey = `${minCode}_${maxCode}_${alarm.alarmDefinitionName || 'default'}`;
        // Return from reactive cache if exists
        if (this.tooltipCache[cacheKey]) {
            return this.tooltipCache[cacheKey];
        }
        // Initialize with loading message (Vue 3 direct assignment is reactive)
        this.tooltipCache[cacheKey] = 'Loading description...';
        // Load description
        MeasurementErrorCodeDescriptionHelper.getDescriptionRange(minCode, maxCode, alarm.alarmDefinitionName).then(description => {
            // Direct assignment works with reactive in Vue 3
            this.tooltipCache[cacheKey] = description;
        }).catch(error => {
            console.error('Failed to load error description', error);
            this.tooltipCache[cacheKey] = 'Error loading description';
        });
        return this.tooltipCache[cacheKey];
    }
    getAlarmValue(alarm) {
        if (this.isErrorAlarm(alarm)) {
            return this.getErrorCodeDisplay(alarm);
        }
        var output = this.getValue(alarm);
        if (output && alarm.uoM) {
            output += " " + alarm.uoM;
        }
        return output;
    }
    getValue(alarm) {
        if (alarm.alarmTypeId == AlarmTypeEnum.StringState)
            return "";
        return MeasurementHelper.getRoundedValueString(alarm.extremeValue == undefined ? null : alarm.extremeValue, alarm.digits);
    }
    ;
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    get systemId() {
        return this.query.systemId;
    }
    ;
    get companyId() {
        return this.query.companyId;
    }
    get company() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get showCompanySelect() {
        return this.companies.length > 2;
    }
    get system() {
        return this.systems.filter(item => {
            return item.systemId == this.systemId;
        })[0] || null;
    }
    ;
    set system(item) {
        if (!item)
            return;
        this.query.systemId = item === null || item === void 0 ? void 0 : item.systemId;
    }
    ;
    get siteId() {
        return this.query.siteId;
    }
    ;
    get site() {
        return this.filteredSites.filter(item => {
            return item.value == this.siteId;
        })[0] || null;
    }
    ;
    set site(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get componentId() {
        return this.query.componentId;
    }
    ;
    get component() {
        return this.systemComponents.filter(item => {
            return item.value == this.componentId;
        })[0] || null;
    }
    ;
    set component(item) {
        if (!item)
            return;
        this.query.componentId = item.value;
    }
    ;
    get alarmTypeId() {
        return this.query.alarmTypeId;
    }
    ;
    get alarmType() {
        return this.alarmTypes.filter(item => {
            return item.value == this.alarmTypeId;
        })[0] || null;
    }
    ;
    set alarmType(item) {
        if (!item)
            return;
        this.query.alarmTypeId = item.value;
    }
    ;
    get alarmSeverityId() {
        return this.query.alarmSeverityId;
    }
    ;
    get alarmSeverity() {
        return this.alarmSeverities.filter(item => {
            return item.value == this.alarmSeverityId;
        })[0] || null;
    }
    ;
    set alarmSeverity(item) {
        if (!item)
            return;
        this.query.alarmSeverityId = item.value;
    }
    ;
    get stringStatusId() {
        return this.query.stringStatusId;
    }
    ;
    get stringState() {
        return this.stringStates.filter(item => {
            return item.value == this.stringStatusId;
        })[0] || null;
    }
    ;
    set stringState(item) {
        if (!item)
            return;
        this.query.stringStatusId = item.value;
    }
    ;
    get alarmStatusId() {
        return this.query.alarmStatusId;
    }
    ;
    get alarmState() {
        return this.alarmStates.filter(item => {
            return item.value == this.alarmStatusId;
        })[0] || null;
    }
    ;
    set alarmState(item) {
        if (!item)
            return;
        this.query.alarmStatusId = item.value;
    }
    ;
    get acknowledgeStatus() {
        return this.acknowledgeStatuses.filter(item => {
            return item.value == this.query.acknowledgeStatus;
        })[0] || null;
    }
    ;
    set acknowledgeStatus(item) {
        if (!item)
            return;
        this.query.acknowledgeStatus = item.value;
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    get numberOfSeletedAlarmSeverities() {
        return this.alarmSeverities.filter(alarmSeverity => alarmSeverity.selected).length;
    }
    ;
    get alarmSeverityOptionText() {
        var _a;
        if (this.numberOfSeletedAlarmSeverities == this.alarmSeverities.length)
            return `Any severity`;
        if (this.numberOfSeletedAlarmSeverities != 1)
            return this.alarmSeverities.filter(alarmSeverity => alarmSeverity.selected).map(alarmSeverity => alarmSeverity.text).join(", ");
        return (_a = this.alarmSeverities.filter(alarmSeverity => alarmSeverity.selected)[0]) === null || _a === void 0 ? void 0 : _a.text;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get queryString() {
        let params = [
            `${this.query.systemId}`,
            `${this.query.siteId}`,
            `${this.query.alarmTypeId}`,
            `${this.query.alarmStatusId}`,
            `${this.query.startTime}`,
            `${this.query.endTime}`
        ];
        return params.join("_");
    }
    ;
    getAlarmEndDate(alarm) {
        return alarm.whenCleared
            ? DateHelper.getDateForQueryString(DateHelper.getEndOfDay(alarm.whenCleared))
            : DateHelper.getDateForQueryString(DateHelper.getEndOfDay(DateHelper.addMonth(alarm.whenRaised, 3)));
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    resetDateFilterOption() {
        this.dateFilterOption = "W";
        this.setDateRange();
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
    }
    ;
    setDateRange() {
        let range = DateHelper.getDateRange(DatePresetOption.OneMonth);
        switch (this.dateFilterOption) {
            case "W":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "M":
                range = DateHelper.getDateRange(DatePresetOption.OneMonth);
                break;
            case "3M":
                range = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                break;
            case "Y":
                range = DateHelper.getDateRange(DatePresetOption.OneYear);
                break;
            case "All":
                range = { start: null, end: null };
                break;
        }
        if (!range)
            return;
        this.query.startTime = range.start;
        this.query.endTime = range.end;
    }
    ;
    get areDatesInvalid() {
        if (this.query.startTime == null || this.query.endTime == null || this.startDateInvalid || this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.query.startTime.toString());
        let endTime = DateHelper.convertToDate(this.query.endTime.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.query.startTime)
            return false;
        try {
            return isNaN(Date.parse(this.query.startTime.toString()));
        }
        catch (_a) {
            return true;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.query.endTime)
            return false;
        try {
            return isNaN(Date.parse(this.query.endTime.toString()));
        }
        catch (_a) {
            return true;
        }
    }
    ;
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
    get isStandardOrHigher() {
        return this.licenseState.isStandardEdition ||
            this.licenseState.isPremiumEdition ||
            this.licenseState.appEdition === AssureEditionEnum.PowershieldCloudStandard;
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], AlarmsVue.prototype, "loginState", void 0);
__decorate([
    State("licenseModule"),
    __metadata("design:type", typeof (_b = typeof LicenseState !== "undefined" && LicenseState) === "function" ? _b : Object)
], AlarmsVue.prototype, "licenseState", void 0);
__decorate([
    Watch("selectAll"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "onSelectAllChanged", null);
__decorate([
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "onColumnsChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "onSortChanged", null);
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "onPageChanged", null);
__decorate([
    Watch("query.startTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "setDefaultStartTime", null);
__decorate([
    Watch("query.endTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "setDefaultEndTime", null);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("query.siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmsVue.prototype, "onSiteIdChanged", null);
AlarmsVue = __decorate([
    Component({
        name: "AlarmsVue",
        components: {
            AlarmCommentsVue
        }
    })
], AlarmsVue);
export default AlarmsVue;
